(function () {
  'use strict';
  var form = document.getElementById('ProductForm');
  var sticky;
  function currentBundle() {
    var selected = document.querySelector('#ProductForm [name="cadence"]:checked');
    return selected ? selected.value === 'bundle' : !!document.querySelector('[data-v3-plan="90"][aria-checked="true"]');
  }
  function paintTerms() {
    var bundle = currentBundle();
    document.querySelectorAll('[data-misu-terms]').forEach(function (p) { p.hidden = (p.dataset.misuTerms === 'bundle') !== bundle; });
    if (sticky) {
      var selected = document.querySelector('#ProductForm [name="cadence"]:checked');
      var boxes = { bundle: '$69.98 first box · 3 pouches', bundle5: '$99.97 first box · 5 pouches' };
      sticky.querySelector('b').textContent = boxes[selected ? selected.value : bundle ? 'bundle' : ''] || '$34.99 first box · 1 pouch';
      sticky.querySelector('small').textContent = 'Refills Ship Every 30 Days';
    }
  }
  if (form && !document.getElementById('ProductSticky')) {
    sticky = document.createElement('a'); sticky.className = 'misu-pdp-jump'; sticky.href = '#ProductForm';
    sticky.innerHTML = '<span><b></b><small></small></span><em>Choose offer →</em>';
    form.closest('main').appendChild(sticky);
    sticky.addEventListener('click', function () { form.scrollIntoView({block:'center'}); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (entries) { sticky.hidden = entries[0].isIntersecting; }, {threshold:0.3}).observe(form);
  }
  if (form) form.addEventListener('change',paintTerms);
  var homeOffers = document.querySelector('[data-v3-offer]');
  if (homeOffers) new MutationObserver(paintTerms).observe(homeOffers,{subtree:true,attributes:true,attributeFilter:['aria-checked']});
  paintTerms();
})();
